// extracted by mini-css-extract-plugin
module.exports = {"statisticsPanel":"StatisticsPanel_statisticsPanel__18QOQ","statisticsPanelBody":"StatisticsPanel_statisticsPanelBody__2xoFV"};